import { mapGetters } from "vuex";
import { constants } from "@/const"
import { upperFirst } from "lodash";
export const brandAndRegionAuthHelper = {
  computed: {
    ...mapGetters([
      "brandAuth",
      "regionAuth",
      "IsMcfa", 
      "IsMcfe", 
      "IsMcfs", 
    ])
  },
  methods: {
    IsBitmapMatch(a, b) {
      //bitwise AND
      return (a & b) > 0;
    },
    IsBrandAuthorized(brandBitmapValue){
      return this.IsBitmapMatch(brandBitmapValue,this.brandAuth);
    },
    IsRegionAuthorized(regionBitmapValue){
      //Currently all of our regions are based in the americas, so region auth check is only relevant and necessary for MCFA
      if(!this.IsMcfa){
        return true;
      }
      regionBitmapValue = regionBitmapValue === 0 ? constants.MAX_AUTH_MASK : regionBitmapValue;
      return this.IsBitmapMatch(regionBitmapValue, this.regionAuth);
    },
    IsBrandRegionAuthorized(brandBitmapValue, regionBitmapValue){    
      var isBrandAuthorized = this.IsBrandAuthorized(brandBitmapValue);
      var isRegionAuthorized = this.IsRegionAuthorized(regionBitmapValue);

      var isBrandRegionAuthorized = isRegionAuthorized && isBrandAuthorized;
      return isBrandRegionAuthorized; 
    }
  }
}